import React from 'react'

import { Field } from 'formik'

import { KeyEventUtil } from 'utils'

import { Form, Col } from '_zari/core'

const NumeroDocumentoPagoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback((e) => {
    KeyEventUtil.leaveOnEnterOrTab('select-flujoEfectivo', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='N. DOC' htmlFor='text-numeroDocumentoPago' md={4} />
      <Col md={8}>
        <Field name='numeroDocumentoPago'>
          {({ field }) => (
            <Form.InputText
              {...field}
              id='text-numeroDocumentoPago'
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NumeroDocumentoPagoFormGroup)
